<template>
    <div class="custom-switch-wrapper" :class="wrapperClass">

        <div class="custom-control custom-switch d-flex" 
        :class="{
            reverse: reverse,
            loading: loading,
            small: small 
        }"> 

            <input 
            class="custom-control-input d-none"
            type="checkbox" 
            :disabled="disabled"
            :id="id" 
            v-model="checked">  
            
            <label 
            :for="id" 
            class="custom-control-label pt-1"
            :class="labelClass">
                {{label}}
                <slot />
            </label>
            
        </div>

        <form-errors v-bind="{errors}" />
        
    </div>
</template>

<script>

    export default {

        props: {
            id: {
                type: String,
                default() {
                    return `checkbox-${this._uid}`
                },
            },

            value: [
                Array,
                Number, 
                Boolean, 
                String, 
                Object
            ],

            label: {
                type: String,
                default: ''
            },

            small: {
                type: Boolean,
                default: true
            },

            disabled: {
                type: Boolean,
                default: false
            },

            loading: {
                type: Boolean,
                default: false
            },

            errors: {
                type: String,
                default: "",
            },

            lang: {
                type: Boolean,
                default: false
            },

            field: {
                type: String,
                default: ''
            },
            
            labelClass: {
                type: String,
                default: 'pl-3'
            },

            wrapperClass: String,
            reverse: Boolean
        },

        computed: {

            val() {
                return this.value
            },

            checked: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }

        }

        

    }

</script>